export const MESSAGE_TYPE = {
  INFO: 'informative',
  POSITIVE: 'positive',
  NEGATIVE: 'error',
  WARNING: 'warning',
};
